export default __webpack_public_path__ + "static/heroralphlauren-c9148b584683420a85265110a0cfcf3a.jpg";